// fetch data from api
import axios from 'axios'
let baseURL;

// check if not production
if (process.env.NODE_ENV !== 'production') {
    // baseURL = process.env.REACT_APP_BASE_URL_LOCAL;
    baseURL = 'https://maroga-server2.onrender.com/';
} else {
    baseURL = 'https://maroga-server2.onrender.com/';
}

// if (process.env.NODE_ENV !== 'production') {
//     baseURL = 'http://localhost:5000/';
// } else {\

//     // Set the production base URL here
//     // Example: baseURL = 'https://your-production-api.com/';
//     baseURL = process.env.REACT_APP_BASE_URL;
// }

const API = axios.create({ baseURL }, { withCredentials: true });
API.interceptors.request.use(req => {
    const token = localStorage.getItem('authenticate');
    req.headers.Authorization = `Bearer ${token}`;
    return req;
}, error => {
    return Promise.reject(error.message);
}
);
export default API;